/** @format */

import { z } from "zod";

export const signUpSchema = z
  .object({
    fullName: z.string().min(1, "Required"),
    shortName: z.string().min(1, "Required"),
    email1: z.string().min(1, "Required").email("Invalid email address"),
    email2: z.string().min(1, "Required").email("Invalid email address"),
    password1: z.string().min(8, "Password must be at least 8 characters"),
    password2: z.string().min(8, "Password must be at least 8 characters"),
  })
  .refine(data => data.email1 === data.email2, {
    message: "Emails must match",
    path: ["email2"],
  })
  .refine(data => data.password1 === data.password2, {
    message: "Passwords must match",
    path: ["password2"],
  });

export type SignUpFormData = z.infer<typeof signUpSchema>;
